<template>
  <div>
    <ProgressBar />
    <div class="mx-auto max-w-5xl px-4 pt-8 pb-12 text-center sm:space-y-4 sm:px-6 sm:py-12 lg:px-6">
      <div class="space-y-5 sm:space-y-4 sm:mx-auto sm:max-w-lg lg:max-w-5xl">
        <p class="mt-4 text-4xl font-bold leading-6 text-gray-800">&#127881;</p>
        <p class="mt-4 text-xl font-bold leading-6 text-gray-800">Herzlichen Glückwunsch</p>
        <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
          Eine E-Mail mit den Vertrags&shy;unterlagen ist auf dem Weg zu Ihnen.
        </h2>
        <p class="py-4 mt-4 text-xl font-bold leading-6 text-gray-800">
          Ihre Auftragsnummer lautet:
          <span class="font-bold text-green-400"> {{ tenant.prefixedOrderId }}</span>
        </p>
      </div>
    </div>
    <!-- how it works -->
    <!-- digital -->
    <div v-if="destination === DELIVERY_TYPE.DIGITAL">
      <div class="bg-gray-50">
        <div class="mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 lg:px-8">
          <div class="space-y-12">
            <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
              Und so geht es jetzt weiter:
            </h2>

            <ul class="mx-auto grid-cols-2 space-y-16 sm:space-y-0 sm:grid sm:gap-16 lg:max-w-7xl">
              <li>
                <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56"
                       src='/images/e-mail-erhalten.png' alt="" loading="lazy">
                  <div class="space-y-2">
                    <div class="text-lg text-green-400 leading-6 space-y-1">
                      <h3 class="font-medium"><a href="/konto"> 1. Dokumente herunterladen </a></h3>
                      <p class="text-gray-600"> Laden Sie sich jetzt Ihre Vertragsdokumente herunter. Diese stehen Ihnen
                        in <a class="underline text-green-400" href="/konto">Ihrem Konto</a> zur Verfügung. Zusätzlich
                        erhalten Sie die Download-Links per E-Mail. </p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56" src='/images/schritt4.png'
                    alt="" loading="lazy">
                  <div class="space-y-2">
                    <div class="text-lg text-green-400 leading-6 space-y-1">
                      <h3 class="font-medium"> 2. Urkunde an Vermieter übergeben </h3>
                      <p class="text-gray-600"> Schicken Sie die Bürgschaftsurkunde als PDF an Ihren Vermieter 
                        oder übergeben Sie Ihrem Vermieter die Urkunde ausgedruckt als Alternative zur Barkaution.</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- paper -->
    <div v-if="destination === DELIVERY_TYPE.NEW_PROPERTY">
      <div class="bg-gray-50">
        <div class="mx-auto max-w-7xl px-4 py-12 text-center sm:px-6 lg:px-8">
          <div class="space-y-12">
            <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
              Und so geht es jetzt weiter:
            </h2>
            <ul class="mx-auto grid-cols-2 space-y-16 sm:space-y-0 sm:grid sm:gap-16 lg:max-w-7xl">
              <li>
                <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56"
                       src='/images/e-mail-erhalten.png' alt="" loading="lazy">
                  <div class="space-y-2">
                    <div class="text-lg text-green-400 leading-6 space-y-1">
                      <h3 class="font-medium"><a href="/konto"> 1. Dokumente herunterladen </a></h3>
                      <p class="text-gray-600"> Laden Sie sich jetzt Ihre Vertragsdokumente herunter. Diese stehen Ihnen
                        in <a class="underline text-green-400" href="/konto">Ihrem Konto</a> zur Verfügung. Zusätzlich
                        erhalten Sie die Download-Links per E-Mail. </p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56" src='/images/schritt4.png'
                    alt="" loading="lazy">
                  <div class="space-y-2">
                    <div class="text-lg text-green-400 leading-6 space-y-1">
                      <h3 class="font-medium"> 2. Urkunde an Vermieter übergeben </h3>
                      <p class="text-gray-600"> Die Bürgschaftsurkunde schicken wir innerhalb von wenigen Werktagen an die
                        angegebene Adresse. Im Anschluss übergeben Sie diese Ihrem Vermieter als Kautionssicherheit. Fertig!</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end of how it works-->
    <div class="mt-10 sm:flex sm:justify-center">
      <a v-if="destination === DELIVERY_TYPE.DIGITAL" href="/konto"
        class="flex items-center justify-center text-center px-4 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-green-400 hover:bg-green-300 sm:px-8 w-full sm:w-auto">
        Dokumente im Konto herunterladen
      </a>
      <a v-if="destination === DELIVERY_TYPE.NEW_PROPERTY" href="/konto"
        class="flex items-center justify-center text-center px-4 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-green-400 hover:bg-green-300 sm:px-8 w-full sm:w-auto">
        Bürgschaft im Konto herunterladen
      </a>
    </div>
    <div class="bg-white">
      <div class="mx-auto max-w-5xl px-4 py-10 text-center sm:space-y-4 sm:px-6 lg:px-6">
        <p class="mt-2 text-sm leading-6 text-gray-600">
          Keine E-Mail erhalten? Haben Sie schon Ihren Spam Ordner gecheckt?<br> Gerne schicken wir Ihnen auf
          Nachfrage eine Kopie der Unterlagen.<br><br>
          Alternativ finden Sie in unseren <span class="text-green-400"><a href="/agb">AGB</a></span> das <span
            class="text-green-400"><a href="/files/vertragsunterlagen_heysafe.pdf">Produktinformationsblatt</a></span>,
          die <span class="text-green-400"><a href="/files/vertragsunterlagen_heysafe.pdf">Vertragsunterlagen</a></span>,
          die <span class="text-green-400"><a href="/files/vertragsunterlagen_heysafe.pdf">allgemeinen
              Versicherungsbedingungen</a></span>
          und die <span class="text-green-400"><a href="/agb">Widerrufsbelehrung</a></span>.
        </p>
      </div>
    </div>

  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useTenantStore } from "../stores/tenant";
import { useProgressBarStore } from "../stores/progress-bar";
import { DELIVERY_TYPE } from "../utils/constants";
import ProgressBar from "../components/ProgressBar.vue";


const props = defineProps({
  id: String,
})

const progressBar = useProgressBarStore();
const tenant = useTenantStore();
const destination = tenant.formValues.next_destAddress;

onMounted(() => {
  tenant.loadUserData(props.id);
  progressBar.setStepsState('danke');
})
</script>
